import React from 'react';

import classnames from 'classnames';

import { INFLUENCERS_URL } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import Loader from 'shared/components/Loader';
import Button from 'shared/components/Button';
import InfluencerBox from 'shared/components/InfluencerBox';

import styles from './styles.module.scss';

const FeaturedInfluencers = ({ push, influencers = [], isFetching }) => (
  <div className={classnames('container', styles.container)}>
    <div className={styles.title}>Featured Influencers</div>
    <div className={styles.description}>
      Discover close to 1,000 PropTech Influencers who are highly sought after
      as speakers, authors and commentators; some of the very best minds in
      global real estate technology.
    </div>
    <div className={styles.influencers}>
      {isFetching ? (
        <Loader className={styles.loader} />
      ) : (
        influencers.map(influencer => (
          <InfluencerBox
            key={`featured-influencer-${influencer.id}`}
            influencer={influencer}
            isSameUser={true}
          />
        ))
      )}
    </div>
  </div>
);

export default WithPush(FeaturedInfluencers);
